import React, { useEffect } from "react";
// import { GoPrimitiveDot } from 'react-icons/go'

import GoogleMapReact from "google-map-react";
import { useState } from "react";
import { FiBarChart } from "react-icons/fi";
import { MdOutlineSupervisorAccount } from "react-icons/md";
import Marker from "../components/Marker";
import { useStateContext } from "../contexts/ContextProvider";
import { useGetAnalyticsQuery } from "../redux/analytics";

const Ecommerce = () => {
  const { currentColor } = useStateContext();

  const { data, isLoading, isSuccess } = useGetAnalyticsQuery({
    page: 1,
    size: 1000,
  });

  // Centrer la carte sur Bamako (Faladié)
  const defaultProps = {
    center: {
      lat: 12.6167, // Latitude de Faladié, Bamako
      lng: -7.9021, // Longitude de Faladié, Bamako
    },
    zoom: 14, // Zoom ajusté pour une vue de proximité
  };

  // Emplacements à proximité de Faladié
  const locations = [
    {
      lat: 12.6175,
      lng: -7.9032,
      text: "Shop",
      details: {
        title: "Boutique Faladié",
        description: "Une boutique populaire pour les vêtements.",
      },
    },
    {
      lat: 12.618,
      lng: -7.9045,
      text: "Hotel",
      details: {
        title: "Hôtel Faladié",
        description: "Un hôtel confortable avec des services de qualité.",
      },
    },
    {
      lat: 12.6158,
      lng: -7.9015,
      text: "Restaurant",
      details: {
        title: "Restaurant Faladié",
        description: "Un restaurant connu pour ses plats locaux.",
      },
    },
  ];
  const [earningData, setEarningData] = useState([
    {
      icon: <MdOutlineSupervisorAccount />,
      amount: "0",
      // percentage: "-4%",
      title: "Non payer",
      iconColor: "#03C9D7",
      iconBg: "#E5FAFB",
      pcColor: "red-600",
    },
    // {
    //   icon: <BsBoxSeam />,
    //   amount: "0",
    //   percentage: "+23%",
    //   title: "Oeuvres",
    //   iconColor: "rgb(255, 244, 229)",
    //   iconBg: "rgb(254, 201, 15)",
    //   pcColor: "green-600",
    // },
    {
      icon: <FiBarChart />,
      amount: "0",
      // percentage: "+38%",
      title: "Payer",
      iconColor: "rgb(228, 106, 118)",
      iconBg: "rgb(255, 244, 229)",

      pcColor: "green-600",
    },
    // {
    //   icon: <HiOutlineRefresh />,
    //   amount: '39,354',
    //   percentage: '-12%',
    //   title: 'Reversés',
    //   iconColor: 'rgb(0, 194, 146)',
    //   iconBg: 'rgb(235, 250, 242)',
    //   pcColor: 'red-600',
    // },
  ]);
  console.log("data", data);

  useEffect(() => {
    if (data && data.data) {
      setEarningData((prevState) => {
        return prevState.map((item, index) => {
          return {
            ...item,
            amount:
              item.title === "Payer"
                ? Number(
                    data.data[index]?.attributes.redevance_payer
                  ).toLocaleString()
                : Number(
                    data.data[index]?.attributes?.redevance_totale ?? 0
                  ).toLocaleString(),
          };
        });
      });
    }
  }, [data]);
  return (
    <div className="mt-12">
      <div className="flex flex-wrap lg:flex-nowrap justify-center">
        <div className="bg-white dark:text-gray-200 flex dark:bg-secondary-dark-bg h-44 rounded-xl w-full lg:w-auto p-8 pt-9 m-3 bg-hero-pattern bg-no-repeat bg-cover bg-center">
          <div className="flex justify-between md:w-72 items-center">
            <div>
              <p className="font-bold text-gray-400">Totale redevances</p>
              <p className="text-xl">
                {Number(
                  data?.data[0].attributes.redevance_totale ?? 0
                ).toLocaleString()}{" "}
                <span className="text-sm text-yellow-600  mb-16 ">Fcfa</span>{" "}
              </p>
            </div>
          </div>
          {/* <div className="mt-6">
            <Button
              color="white"
              bgColor={currentColor}
              text="Télécharger"
              borderRadius="10px"
              size="md"
            />
          </div> */}
        </div>

        <div className="flex m-3 flex-wrap justify-center gap-1 items-center">
          {earningData.map((item) => (
            <div
              key={item.title}
              className="bg-white dark:text-gray-200 dark:bg-secondary-dark-bg md:w-72 p-4 pt-9 rounded-2xl">
              <button
                type="button"
                style={{ color: item.iconColor, backgroundColor: item.iconBg }}
                className="text-2xl opacity-0.9 rounded-full p-4 hover:drop-shadow-xl">
                {item.icon}
              </button>
              <p className="mt-3">
                <span className="text-lg font-semibold">{item.amount}</span>
                <span className={`text-sm text-${item.pcColor} ml-2`}>
                  {item.percentage}
                </span>
              </p>
              <p className="text-sm text-gray-400 mt-1"> {item.title} </p>
            </div>
          ))}
        </div>
      </div>

      <div className="flex gap-10 w-full flex-wrap justify-center">
        <div className="bg-white w-full dark:text-gray-200 dark:bg-secondary-dark-bg m-3 rounded-2xl md:w-4/5">
          <div style={{ height: "60vh", width: "100%" }}>
            <GoogleMapReact
              bootstrapURLKeys={{ key: "" }}
              defaultCenter={defaultProps.center}
              defaultZoom={defaultProps.zoom}
              yesIWantToUseGoogleMapApiInternals>
              {locations.map((location, index) => (
                <Marker
                  key={index}
                  lat={location.lat}
                  lng={location.lng}
                  text={location.text}
                  details={location.details}
                />
              ))}
            </GoogleMapReact>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ecommerce;
